<header class="mobile-hide">
</header>
<section>
    <div class="container main-div">
        <div class="login d-flex justify-content-center">
            <div class="col-lg-10 exp-div">
                <div class="row">
                    <div class="col-md-5 d-flex align-items-center right-div-main mobile-hide">
                        <div class="right-div">
                            <div>
                                <h2>Sign Up</h2>
                            </div>
                            <div>
                                <a href="/" class="logo"><img [src]="brand.logo" alt="Scan My Invoice"></a>

                                <p class="about">Signup to get First
                                    crack at the Invoice
                                    Processing Features</p>
                                </div>
                            
                        </div>
                    </div>                
                    <div class="col-md-7 d-flex align-items-center left-div-main">
                        <div class="left-div full-width">
                            <!-- <a href="/" class="mobile-logo"><img src="/assets/img/logo.png" alt="Scan My Invoice"></a> -->
                            <h2 class="mobile-logo">Sign Up</h2>                        
                            <!-- <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p> -->
                            <form method="post" [formGroup]="signUpForm" (ngSubmit)="onSubmit()">
                                <div class="errrorMsg" *ngIf="errorMsg">{{ errorMsg }}</div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <label class="frm-label">Name</label>
                                        <mat-form-field appearance="outline" class="full-width">
                                            <mat-label>Enter Your Name</mat-label>
                                            <input type="text" matInput placeholder="Your Name" name="name" formControlName="name">
                                            <mat-error *ngIf ="!signUpForm.controls['name'].valid && signUpForm.controls['name'].touched" >Please enter your name</mat-error>
                                        </mat-form-field>
                                    </div>
        
                                    <div class="col-md-12">
                                        <label class="frm-label">Organization</label>
                                        <mat-form-field appearance="outline" class="full-width">
                                            <mat-label>Enter Organization Name</mat-label>
                                            <input type="text" matInput placeholder="Organization Name" name="organization" formControlName="organization">
                                            <mat-error *ngIf ="!signUpForm.controls['organization'].valid && signUpForm.controls['organization'].touched" >Please enter organization name</mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-md-12">
                                        <label class="frm-label">What best describes you ? *</label>
                                        <mat-radio-group class="radiogroup full-width" formControlName="businessModel">
                                        <mat-radio-button class="radiogroupbutton" value="owner">Business Owner or Employee</mat-radio-button>
                                        <mat-radio-button class="radiogroupbutton" value="individual">Individual</mat-radio-button>   
                                        <!-- <mat-error *ngIf="radioButtons.radiot.touched">Required</mat-error>                                    -->
                                        </mat-radio-group>
                                    </div>
                                    

                                    <div class="col-md-12">
                                        <label class="frm-label">Email</label>
                                        <mat-form-field appearance="outline" class="full-width">
                                            <mat-label>Enter Your Email</mat-label>
                                            <input type="email" matInput placeholder="name@domain.com" name="email" formControlName="email">
                                            <mat-error *ngIf = "!signUpForm.controls['email'].valid && signUpForm.controls['email'].touched">Please enter valid email address</mat-error>
                                        </mat-form-field>
                                    </div>


                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-4">
                                                <mat-label>Country</mat-label>
                                                <mat-form-field appearance="outline" class="full-width">
                                                    <mat-select formControlName="country" (selectionChange)="countryChangeFun($event)">
                                                        <!-- <mat-option *ngFor="let row of district" [value]="row.district">
                                                            {{ row.district }}
                                                        </mat-option> -->
                                                        <mat-option value="india" selected>India
                                                        </mat-option>                                                  
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-8">
                                                <label class="frm-label">Phone</label>
                                                <mat-form-field appearance="outline"  class="full-width">
                                                    <mat-label>Enter Your Phone</mat-label>
                                                    <input type="text" matInput placeholder="Your Phone" name="phone" formControlName="phone">
                                                    <mat-error *ngIf = "!signUpForm.controls['phone'].valid && signUpForm.controls['phone'].touched" >Please enter valid phone number</mat-error>
                                                </mat-form-field>
                                            </div>  
                                        </div>
                                    
                                    </div>

                                    <div class="col-md-12 text-center">
                                        <button mat-fab class="radius-20-ico" aria-label="icon-button with a east icon">
                                            Proceed
                                            <mat-icon fontIcon="login"></mat-icon>
                                        </button>
                                        <p class="mt-2">
                                            By proceeding, you agree to our <a href="#">Terms of Service</a>
                                            and <a href="#">Privacy Notice</a>.                                        
                                        </p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                </div>
            </div>
            
        </div>
    
    </div>
</section>
<footer class="mobile-hide">

</footer>
